import React, { Component } from 'react';
import NewsDetails from '../components/NewsDetails'; 
import NewsBox from '../components/NewsBox'; 

class NewsDetailsContainer extends Component {
  componentWillMount(){
	if(this.props.resolves.page.visibility==='protected'){
		const {stateService} = this.props.transition.router;				
		stateService.go("root.home");
	}
	document.body.scrollTop = document.documentElement.scrollTop = 0;
  }		
  componentDidMount(){	 
	setTimeout(function(){
		document.getElementById('menu-informationen').classList.add('active');
		document.getElementById('submenu-neuigkeiten').classList.add('active');
	},400);	
  }
  componentWillUnmount(){
	document.getElementById('submenu-neuigkeiten').classList.remove('active');
	document.getElementById('menu-informationen').classList.remove('active');
  }
  render() {
		   const {page} = this.props.resolves;
		   const {name,slug,text,date,image} = page.next_post;
		   return (
                <div className="container-fluid lg-side-padding">
					<div className="row">
						<NewsDetails {...page} />
						<section className="col-md-4 sidebar article-list style1">
							{
								(page.next_post)?
								<NewsBox 
									left = ""
									right =""
									name = {name}
									slug = {slug}
									image = {image}
									date = {date}
									text = {text}		
									staticData={this.props.resolves.staticData}	
								/>:null
							}
						</section>
					</div>
				</div>
            )
       
  }
}
export default NewsDetailsContainer;


// WEBPACK FOOTER //
// ./src/containers/NewsDetailsContainer.js